import {handleSend} from '../post'

export const update605001 = (data) => {
  return handleSend(data, '60', '5001', data.operaType)
}

// 供应商ID id
// 所属商户号 merchId
// 所属商户 merchname
// 供应商名称 supplierName
// 联系人 contactsMan
// 联系电话 phoneNo
// 电子邮箱 email
// 地址 address
// 备注 remark
// 资质有效期 qualifyExpDt
// 状态 status
// 状态 statusName
export const list605002 = (data) => {
  data.pageNum = String(data.pageNum)
  data.pageSize = String(data.pageSize)
  return handleSend(data, '60', '5002', '0', 'message')
}

export const update605003 = (data) => {
  // operaType
  // supplierId
  // qualifyExpDt
  return handleSend(data, '60', '5003', data.operaType)
}

export const HxApiSupplier = {
  update605001,
  list605002,
  update605003
}



// WEBPACK FOOTER //
// ./src/api/erp/info/supplier.js